/* ===========================
   SAGACITY THEME — theme.js
   =========================== */
(function () {
  'use strict';

  /* ─── DOM Ready ─────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMobileMenu();
    initHeroParallax();
    initDragScroll();
    initProductPage();
    initAccordions();
    initCartCount();
    initNewsletter();
    initCartPage();
  });

  /* ─── HEADER: transparent → solid on scroll ─ */
  function initHeader() {
    var header = document.getElementById('site-header');
    if (!header) return;

    var hero = document.querySelector('.hero');
    if (!hero) {
      header.classList.add('header--solid');
      return;
    }

    header.classList.add('header--transparent');

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) {
          header.classList.remove('header--solid');
          header.classList.add('header--transparent');
        } else {
          header.classList.remove('header--transparent');
          header.classList.add('header--solid');
        }
      },
      { threshold: 0.05 }
    );
    observer.observe(hero);
  }

  /* ─── MOBILE MENU ────────────────────────── */
  function initMobileMenu() {
    var trigger = document.getElementById('mobile-menu-trigger');
    var menu    = document.getElementById('mobile-menu');
    var close   = document.getElementById('mobile-menu-close');
    if (!trigger || !menu) return;

    function open() {
      menu.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
      menu.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', open);
    if (close) close.addEventListener('click', closeMenu);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  /* ─── HERO PARALLAX (disabled) ──────────── */
  function initHeroParallax() {
    return;
  }

  /* ─── DRAG-SCROLL (Image Gallery) ───────── */
  function initDragScroll() {
    var track = document.querySelector('.image-gallery__track');
    if (!track) return;

    var isDown  = false;
    var startX  = 0;
    var scrollL = 0;

    track.addEventListener('mousedown', function (e) {
      isDown  = true;
      startX  = e.pageX - track.offsetLeft;
      scrollL = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () { isDown = false; });
    track.addEventListener('mouseup',    function () { isDown = false; });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      var x    = e.pageX - track.offsetLeft;
      var walk = (x - startX) * 1.8;
      track.scrollLeft = scrollL - walk;
    });

    /* Touch */
    track.addEventListener('touchstart', function (e) {
      startX  = e.touches[0].pageX - track.offsetLeft;
      scrollL = track.scrollLeft;
    }, { passive: true });
    track.addEventListener('touchmove', function (e) {
      var x    = e.touches[0].pageX - track.offsetLeft;
      var walk = (x - startX) * 1.8;
      track.scrollLeft = scrollL - walk;
    }, { passive: true });
  }

  /* ─── PRODUCT PAGE ───────────────────────── */
  function initProductPage() {
    initSizeSelector();
    initQuantityBtns();
    initGalleryThumbs();
    initProductForm();
  }

  function initSizeSelector() {
    var btns = document.querySelectorAll('.size-btn');
    if (!btns.length) return;

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (this.disabled) return;
        btns.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        /* Update the hidden variant id input */
        var variantInput = document.querySelector('input[name="id"]');
        if (variantInput && this.dataset.variantId) {
          variantInput.value = this.dataset.variantId;
        }
      });
    });
  }

  function initQuantityBtns() {
    var input = document.querySelector('.qty-input');
    if (!input) return;

    var inc = document.querySelector('.qty-btn--inc');
    var dec = document.querySelector('.qty-btn--dec');

    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value || 1) + 1;
    });
    if (dec) dec.addEventListener('click', function () {
      var v = parseInt(input.value || 1);
      if (v > 1) input.value = v - 1;
    });
  }

  function initGalleryThumbs() {
    var thumbs  = document.querySelectorAll('.product-page__thumb');
    var mainImg = document.querySelector('.product-page__gallery-main img');
    if (!thumbs.length || !mainImg) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');

        var newSrc = this.querySelector('img').getAttribute('src');
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = newSrc;
          mainImg.style.opacity = '1';
        }, 180);
      });
    });
  }

  function initProductForm() {
    var form = document.querySelector('.product-form');
    if (!form) return;

    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      var btn         = form.querySelector('[type="submit"]');
      var origText    = btn.textContent;
      var formData    = new FormData(form);

      btn.textContent = 'Adding...';
      btn.disabled    = true;

      try {
        var res = await fetch('/cart/add.js', {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id:       formData.get('id'),
            quantity: parseInt(formData.get('quantity')) || 1
          })
        });

        if (!res.ok) throw new Error();

        btn.textContent = 'Added ✓';
        showToast('Item added to cart');
        updateCartCount();

        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled    = false;
        }, 2200);

      } catch (_) {
        btn.textContent = 'Something went wrong';
        setTimeout(function () {
          btn.textContent = origText;
          btn.disabled    = false;
        }, 2200);
      }
    });
  }

  /* ─── ACCORDIONS ─────────────────────────── */
  function initAccordions() {
    var triggers = document.querySelectorAll('.accordion-trigger');
    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var body = document.getElementById(this.getAttribute('aria-controls'));
        var isOpen = this.classList.contains('is-open');

        /* Close all */
        triggers.forEach(function (t) {
          t.classList.remove('is-open');
          var b = document.getElementById(t.getAttribute('aria-controls'));
          if (b) b.classList.remove('is-open');
        });

        if (!isOpen && body) {
          this.classList.add('is-open');
          body.classList.add('is-open');
        }
      });
    });
  }

  /* ─── CART COUNT ─────────────────────────── */
  function initCartCount() { updateCartCount(); }

  async function updateCartCount() {
    try {
      var res  = await fetch('/cart.js');
      var cart = await res.json();
      var els  = document.querySelectorAll('.header__cart-count');
      els.forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (_) {}
  }

  /* ─── NEWSLETTER ─────────────────────────── */
  function initNewsletter() {
    var form = document.querySelector('.newsletter__form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input   = form.querySelector('.newsletter__input');
      var success = document.querySelector('.newsletter__success');
      if (!input.value.trim()) return;

      if (success) { success.style.display = 'block'; }
      input.value = '';
      showToast('Thank you for subscribing!');
    });
  }

  /* ─── CART PAGE: qty / remove ────────────── */
  function initCartPage() {
    var cartForm = document.querySelector('.cart-form');
    if (!cartForm) return;

    cartForm.addEventListener('click', async function (e) {
      var removeBtn = e.target.closest('.cart-item__remove-btn');
      if (removeBtn) {
        e.preventDefault();
        var key = removeBtn.dataset.key;
        await updateCartItem(key, 0);
        removeBtn.closest('.cart-item').remove();
        updateCartTotals();
        updateCartCount();
      }
    });

    cartForm.addEventListener('change', async function (e) {
      if (e.target.classList.contains('cart-item__qty-select')) {
        var key = e.target.dataset.key;
        var qty = parseInt(e.target.value);
        await updateCartItem(key, qty);
        updateCartTotals();
        updateCartCount();
      }
    });
  }

  async function updateCartItem(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
    } catch (_) {}
  }

  function updateCartTotals() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var subtotalEl = document.querySelector('.cart-subtotal');
        if (subtotalEl) {
          subtotalEl.textContent = formatMoney(cart.total_price);
        }
      })
      .catch(function () {});
  }

  function formatMoney(cents) {
    return 'Rs. ' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* ─── TOAST ──────────────────────────────── */
  function showToast(msg) {
    var toast = document.querySelector('.flash-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'flash-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.classList.add('is-visible');
    clearTimeout(toast._timer);
    toast._timer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  }

})();
